module.exports = __webpack_public_path__ + "static/media/rightHand.1960ae0a.svg";